import React, { useState, useEffect, useContext } from "react";
import Table from "react-bootstrap/Table";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getOrders, deleteOders, deleteItems } from "../api";
import { Button, Form, InputGroup, Row, Col, Container } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
const OrderTable = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const today = new Date().toISOString().slice(0, 10);

  const [orderData, setOrderData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "id", direction: "desc" });
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getOrders()
      .then((res) => {
        console.log("Fetched orders:", res.data);
        setOrderData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error fetching orders");
        console.error('Error fetching orders:', err);
        setLoading(false);
      });
  }, []);

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  const handleEdit = (orderId) => {
    navigate(`/editorder/${orderId}`);
  };

  const handleDelete = (orderId) => {
    deleteItems(orderId)
      .then(() => {
        deleteOders(orderId)
          .then(() => {
            setOrderData((prev) => prev.filter(order => order.id !== orderId));
            alert("Order deleted successfully");
          })
          .catch((error) => {
            alert("Error deleting order");
            console.error("Error deleting order:", error);
          });
      })
      .catch((error) => {
        alert("Error deleting order items");
        console.error("Error deleting order items:", error);
      });
  };

  const filteredData = orderData.filter((order) => {
    const orderDate = new Date(order.date).toISOString().slice(0, 10);
    return orderDate >= fromDate && orderDate <= toDate;
  });

  const sortedData = [...filteredData].sort((a, b) => {
    const { key, direction } = sortConfig;
    if (!key) return 0;
    const aVal = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
    const bVal = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];
    if (aVal < bVal) return direction === "asc" ? -1 : 1;
    if (aVal > bVal) return direction === "asc" ? 1 : -1;
    return 0;
  });

  const columns = [
    "id",
    "date",
    "time",
    "customer_id",
    "cash_received",
    "cash_received_through",
    "cash_paid",
    "cash_paid_through",
    "balance",
    "notes",
  ];

  const totals = filteredData.reduce(
    (acc, order) => {
      const cr = Number(order.cash_received || 0);
      const cp = Number(order.cash_paid || 0);
      const bal = Number(order.balance || 0);
  
      acc.cash_received += cr;
      acc.cash_paid += cp;
      acc.balance += bal;
  
      const crMode = order.cash_received_through?.toLowerCase();
      const cpMode = order.cash_paid_through?.toLowerCase();
  
      if (crMode === "gpay") acc.cash_received_gpay += cr;
      if (crMode === "cash") acc.cash_received_cash += cr;
  
      if (cpMode === "hdfc") acc.cash_paid_hdfc += cp;
      if (cpMode === "indian bank") acc.cash_paid_indian += cp;
      if (cpMode === "paynearby") acc.cash_paid_paynearby += cp;
      if (cpMode === "credit card") acc.cash_paid_credit += cp;
  
      return acc;
    },
    {
      cash_received: 0,
      cash_paid: 0,
      balance: 0,
      cash_received_gpay: 0,
      cash_received_cash: 0,
      cash_paid_hdfc: 0,
      cash_paid_indian: 0,
      cash_paid_paynearby: 0,
      cash_paid_credit: 0,
    }
  );
  


  if (loading) return <p>Loading...</p>;

  return (
    <Container className="mt-4">
    {!user ? (
        <div>
            <h2 className="text-center mb-4 text-danger">Please Login..</h2>
        </div>
    ) : (
    <div className="p-4">
      <h2 className="mb-3">Orders</h2>

      {/* Date filters */}
      <Row className="mb-3">
        <Col md={3}>
          <Form.Group controlId="fromDate">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group controlId="toDate">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Orders Table */}
      <Table striped bordered hover responsive>
        <thead className="table-light">
          <tr>
            {columns.map((col) => (
              <th
                key={col}
                onClick={() => handleSort(col)}
                style={{ cursor: "pointer" }}
              >
                {col}{" "}
                {sortConfig.key === col && (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>
            ))}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((order) => (
            <tr key={order.id}>
              {columns.map((col) => (
                <td key={col}>
                  {/* console.log("Order data:", order[col]); */}
                  {col === "date"
                    ? new Date(order[col]).toISOString().slice(0, 10)
                    : order[col]}
                </td>
              ))}
              {user.is_admin?(<td className="text-center">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleEdit(order.id)}
                >
                  <FaEdit />
                </Button>{" "}
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleDelete(order.id)}
                >
                  <FaTrash />
                </Button>
              </td>):(<></>)}
            </tr>
          ))}
        </tbody>
        <tfoot>
  <tr>
    <td colSpan={columns.length + 1}>
      <div className="summary-container p-3 rounded bg-light">
        <div className="row g-3">
          <div className="col-md-4">
            <strong>Total Cash Received:</strong> ₹{totals.cash_received}
          </div>
          <div className="col-md-4">
            <strong>Received via GPay:</strong> ₹{totals.cash_received_gpay}
          </div>
          <div className="col-md-4">
            <strong>Received via Cash:</strong> ₹{totals.cash_received_cash}
          </div>

          <div className="col-md-4">
            <strong>Total Cash Paid:</strong> ₹{totals.cash_paid}
          </div>
          <div className="col-md-4">
            <strong>Paid via HDFC:</strong> ₹{totals.cash_paid_hdfc}
          </div>
          <div className="col-md-4">
            <strong>Paid via Indian Bank:</strong> ₹{totals.cash_paid_indian}
          </div>

          <div className="col-md-4">
            <strong>Paid via Paynearby:</strong> ₹{totals.cash_paid_paynearby}
          </div>
          <div className="col-md-4">
            <strong>Paid via Credit Card:</strong> ₹{totals.cash_paid_credit}
          </div>
          <div className="col-md-4">
            <strong>Total Credit:</strong> ₹{totals.balance}
          </div>
        </div>
      </div>
    </td>
  </tr>
</tfoot>


      </Table>
    </div>)}
    </Container>
  );
};

export default OrderTable;
